import { useDefaultObservableBoolean } from "observables/BooleanObservable";
import { useDefaultObservableOptionModel } from "observables/OptionModelObservable";
import { useTranslation } from "react-i18next";
import { createComponent } from "utils/libExtend/createComponent";

import { CompareYearProps } from "./CompareYear.props";
import { SCompareYear } from "./CompareYearStyled/SCompareYear.styled";
import { SCompareYearSelector } from "./CompareYearStyled/SCompareYearSelector.styled";

export const CompareYear = createComponent<CompareYearProps>("CompareYear", (props) => {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";
  const { service } = props;

  const value = useDefaultObservableOptionModel(service.state.value);
  const valid = useDefaultObservableBoolean(service.state.valid);
  const showError = useDefaultObservableBoolean(service.state.showError);

  return (
    <SCompareYear isArabic={isArabic}>
      <span>{t("dynamicPage.yearInputTitle")}</span>
      <SCompareYearSelector isError={showError && !valid} onChange={service.controller.onChange} value={value} optionList={service.state.optionList} />
    </SCompareYear>
  );
});
